import { useQuery, ApolloError } from '@apollo/client'

import { TRADES } from '@libs/apollo/queries'

import { Trade } from '@types'

interface Data {
  trades?: Trade[]
}

export const useTrades = (): {
  loading: boolean
  error: ApolloError | undefined
  refetch: () => void
  data?: Data
} => {
  const { loading, error, data, refetch } = useQuery<Data>(TRADES, {
    notifyOnNetworkStatusChange: true,
  })

  const refetchData = () => {
    refetch()
  }

  return { loading, error, data, refetch: refetchData }
}
